<template>
  <div class="container coupon">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item>联报管理</el-breadcrumb-item>
        <el-breadcrumb-item>联报列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">联报列表</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleJointCreate"
          >添加联报</el-button>
        </div>
      </div>
    </div>
    <!--     <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="拼团名称"
          prop="name"
        >
          <el-input
            v-model="query.name"
            placeholder="输入拼团名称"
            @input="fetchActivityList()"
          ></el-input>
        </el-form-item>
      </el-form>
    </div> -->
    <div class="results card">
      <div class="table-header">
        <h3 class="title">联报列表</h3>
        <el-form
          size="small"
          :inline="true"
        >
          <el-form-item>
            <el-radio-group
              v-model="query.status"
              @change="fetchActivityList()"
            >
              <el-radio-button
                v-for="(item, index) in filter.status"
                :key="index"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="联报名称"
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名称"
            min-width="260"
            align="center"
          >
            <template slot-scope="scope">
              <div class="item-table-column">
                {{formateMasterProduct(scope.row)}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_count"
            label="联报数量"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.products.length }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="有效期"
            width="200"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>
                {{ $moment(scope.row.start_time).format("YYYY.MM.DD") }}
                -
              </span>
              <span>
                {{ $moment(scope.row.end_time).format("YYYY.MM.DD") }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="order_amount"
            label="创建时间"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.create_time).format("YYYY.MM.DD") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="creator"
            label="创建人"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                type="danger"
                v-show="scope.row.status == 0"
              >已下线</el-tag>
              <el-tag
                type="success"
                v-show="scope.row.status == 1"
              >进行中</el-tag>
              <el-tag
                type="info"
                v-show="scope.row.status == 2"
              >未开始</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToJointRemove(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToJointRemove(scope.row, scope.$index)"
                      style="font-size:16px;color:#F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  joinlist,
  jointDestory
} from "@/api/operation";

export default {
  data() {
    return {
      ruleDialog: false,
      editRow: {
        ref_content: {},
      },
      query: {
        name: "",
        status: "1",
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "未开始", value: "2" },
          { label: "进行中", value: "1" },
          { label: "已下线", value: "0" },
        ]
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.parseQuery();
    this.fetchActivityList();
    this.$store.dispatch('getAdminList')
  },
  methods: {
    // 拼团列表请求
    fetchActivityList() {
      joinlist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchActivityList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchActivityList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchActivityList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchActivityList();
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: "正常",
        2: "关闭",
      };
      if (type == "status") {
        return status[value] || "";
      }
      return "";
    },
    // 创建
    handleJointCreate() {
      this.$router.push(`/joint/create`);
    },
    // 拼团编辑
    handleToActivityEdit(row) {
      this.$router.push(`/activity/edit/${row.id}`);
    },
    // 拼团删除
    handleToJointRemove(row) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          jointDestory({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`);
            this.fetchActivityList();
          });
        })
        .catch(() => { });
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handleToEdit(row) {
      this.$router.push(`/joint/edit?id=${row.id}`)
    },

    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
    formateMasterProduct(row) {
      return row.products.find((v) => { return v.id == row.master_product_id }).name
    }
  },
};
</script>

<style scoped lang="less">
.coupon {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    width: 100.5%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-link {
    font-size: 12px;
  }
  .item-table-column {
    text-align: left;
  }
}
</style>
